import axios from "axios";
import { API_URL } from "./const";

export const fetchTestimonials = async () => {
  return axios
    .get(`${API_URL}/coworking/testimonial`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const deleteTestimonial = async (id) => {
  return axios
    .delete(`${API_URL}/coworking/testimonial/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const addTestimonial = async (data) => {
  return axios
    .post(`${API_URL}/coworking/testimonial`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const getTestimonial = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/coworking/testimonial/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const editTestimonial = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/coworking/testimonial/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
